(function () {
    'use strict';

    angular
        .module('app')
        .factory('requiredFieldsService', requiredFieldsService);

    requiredFieldsService.$inject = ['$http', '$q', '$filter', 'columnFactory', '$timeout', 'zcs', 'selectionCommandService', '$injector', 'extractionservice', 'loginService'];

    function requiredFieldsService($http, $q, $filter, columnFactory, $timeout, zcs, selectionCommandService, $injector, extractionservice, loginService) {
        var service = {
            _enabled: null,
            checkRequiredFields: checkRequiredFields,
            showPopup: false,
            closeDialog: closeDialog,
            processRecord: processRecord,
            updateRecord: updateRecord,
            currentRecord: {},
            currentLibSettings: {},
            command: "",
            commandCode: 0,
            showErrorDialog: showErrorDialog,
            showErrorFields: false,
            closeError: closeError,
            UpdateDocument: UpdateDocument,
            holdUpdate: false,
            checkLibrary: checkLibrary,
            hideCancelAll: false,
            processQueue: processQueue,
            addToQueue: addToQueue,
            recordQueue: []
        };

        var showDialogDeffered;

        var nonEditableReasons = {
            0: "Unknown",
            1: loginService.resourceStrings["RF_NOEDITRIGHTS"],
            2: loginService.resourceStrings["RF_NOPROTECTEDRIGHTS"],
            3: loginService.resourceStrings["RF_NOEDITABLEFIELD"],
            4: loginService.resourceStrings["RF_NOUPDATEDOCRIGHTS"],
            5: loginService.resourceStrings["RF_NOTCREATOR"]

        }

        //checks if required fields plugin is enabled
        function isEnabled() {
            var deferred = $q.defer();

            //if enabled has never been set, check with the server
            if (service._enabled === null) {
                $http.get('../synergis.webapi/api/requiredfields/isenabled').then(function (resp) {
                    service._enabled = resp.data;
                    deferred.resolve(service._enabled);
                }, function (error) {
                    deferred.resolve(false);
                });
            }
            else {
                deferred.resolve(service._enabled);
            }


            return deferred.promise;
        }

        //used to check if required fields applies to the given records
        function checkRequiredFields(items, command) {
            var deferred = $q.defer();
            var selectionItems = [];

            angular.forEach(items, function (item) {
                if (item.selectionItem)
                    selectionItems.push(item.selectionItem);
                else
                    selectionItems.push(item);
            });


            //first, check if it's enabled
            isEnabled().then(function (enabled) {
                if (enabled) {
                    //check the records
                    checkRecords(selectionItems, command).then(function (requiredFieldsData) {
                        if (bowser.windows)
                            deferred.resolve(requiredFieldsData);
                        else {
                            // Defect: 27233: if not running on windows, the field cannot be updated. We show the message that the user must be a creator.
                            for (var record in requiredFieldsData) {
                                angular.forEach(requiredFieldsData[record].Fields, function (field) {
                                    field.NoEditableReason = 5;
                                    field.Editable = false;
                                });
                            }
                            deferred.resolve(requiredFieldsData);
                        }


                    }, function (error) {
                        deferred.reject(error);
                    });
                }
                else {
                    deferred.resolve({});
                }
            });
            return deferred.promise;
        }


        //gets a list of selection items and sends them to the server to verify if there are any required fields
        function checkRecords(selectionItems, command) {
            var deferred = $q.defer();

            $http({
                url: '../Synergis.WebApi/api/requiredfields/checkrecords?command='.concat(command),
                method: 'POST',
                data: JSON.stringify(selectionItems),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                showDialogDeffered = $q.defer();
                showErrorDialog(error.data.Message).then(function () {
                    deferred.reject();
                });
            });
            return deferred.promise;
        }

        function processRecord(record, libSettings, title, command, hideCancelAll, holdUpdate) {
            var deferred = $q.defer();
            service.command = title;
            service.commandCode = command;
            if (libSettings) {
                isEnabled().then(function (enabled) {
                    if (enabled) {
                        service.currentRecord = record;

                        showDialog(libSettings, command, hideCancelAll, holdUpdate).then(function (result) {
                            deferred.resolve(result);
                        });

                    }
                    else {
                        deferred.resolve("OK");
                    }
                });
            }
            else {
                deferred.resolve("OK");
            }

            return deferred.promise;
        }

        function checkLibrary(libId, ext, command) {
            var deferred = $q.defer();

            $http({
                url: '../Synergis.WebApi/api/requiredfields/CheckForNewRecord?libId=' + libId + '&ext=' + ext + '&command=' + command,
                method: 'GET',
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                showDialogDeffered = $q.defer();
                showErrorDialog(error.data.Message).then(function () {
                    deferred.reject();
                });
            });
            return deferred.promise;
        }

        function updateRecord(record, callUpdateDocument) {
            if (typeof callUpdateDocument === 'undefined') {
                callUpdateDocument = true;
            }
            var deferred = $q.defer();
            if (!record) {
                if (service.currentRecord) {
                    record = {
                        tableNumber: service.currentRecord.tableNumber,
                        fileId: service.currentRecord.fileId,
                        majRev: service.currentRecord.majRev,
                        minRev: service.currentRecord.minRev,
                        filename: service.currentRecord.filename,
                        librarySettings: service.currentLibSettings
                    }
                }
            }

            if (record) {

                if (!record.librarySettings) {
                    record.librarySettings = service.currentLibSettings;
                }
                var urlParams = "tableNumber=" + record.tableNumber + "&fileId=" + record.fileId + "&majRev=" + record.majRev + "&minRev=" + record.minRev;
                $http({
                    url: '../Synergis.WebApi/api/requiredfields/updaterecord?'.concat(urlParams),
                    method: 'PUT',
                    data: JSON.stringify(record.librarySettings),
                    headers: {
                        "Content-Type": "application/json"
                    }
                }).then(function (response) {

                    //get columns
                    columnFactory.getAllColumns().then(function (columns) {
                        if (columns.data) {
                            columns = columns.data;
                        }

                        //get field defs
                        var fieldValues = {};
                        angular.forEach(record.librarySettings.Fields, function (field) {
                            var fieldDef = $filter('filter')(columns, { fieldName: field.Name })[0];
                            fieldValues[fieldDef.fieldID] = field.UpdatedValue;
                        });


                        var dataCardService = $injector.get('dataCardService');

                        //set the datacard service document
                        dataCardService.currentRecord = {
                            SCHEMA_S_SRCDB: record.tableNumber,
                            SCHEMA_S_FILEID: record.fileId,
                            SCHEMA_S_MAJREV: record.majRev,
                            SCHEMA_S_MINREV: record.minRev,
                            SCHEMA_S_LONGNAME: record.filename,
                            SCHEMA_S_LIBID: record.libraryId
                        };

                        ///////////////////////////////////////////////////////////
                        // Update Document - Required Fields
                        dataCardService.getCurrentRecordData().then(function (r) {
                            if (callUpdateDocument === true && r.data.updateDocumentEnabled) {
                                dataCardService.UpdateDocument(fieldValues,
                                    dataCardService.currentRecord.SCHEMA_S_LONGNAME,
                                    dataCardService.currentRecord.SCHEMA_S_SRCDB,
                                    dataCardService.currentRecord.SCHEMA_S_FILEID,
                                    dataCardService.currentRecord.SCHEMA_S_MAJREV,
                                    dataCardService.currentRecord.SCHEMA_S_MINREV,
                                    dataCardService.currentRecord.SCHEMA_S_LIBID
                                ).then(function () {
                                    
                                    dataCardService.unTag();
                                    deferred.resolve();
                                }, function (response) {
                                    deferred.reject(response);
                                });
                            }
                            else {
                                dataCardService.unTag();
                                deferred.resolve();
                            }
                        });
                    });
                }, function (error) {
                    deferred.reject(error);
                });
            }
            else {
                deferred.resolve();
            }

            return deferred.promise;
        }

        function showDialog(libSettings, command, hideCancelAll, holdUpdate) {
            service.hideCancelAll = hideCancelAll;
            service.holdUpdate = holdUpdate;
            showDialogDeffered = $q.defer();
            columnFactory.getAllColumns().then(function (columns) {
                if (columns.data) {
                    columns = columns.data;
                }


                //if there is at least 1 field not editable for any reason, we cannot proceed
                console.log(libSettings);
                var nonEditable = $filter('filter')(libSettings.Fields, { Editable: false });
                service.currentLibSettings = libSettings;
                if (nonEditable.length === 0) {
                    angular.forEach(libSettings.Fields, function (field) {
                        var fieldDef = $filter('filter')(columns, { fieldName: field.Name })[0];
                        //field.UpdatedValue = "";
                        field.fieldDef = fieldDef;
                    });

                    var missingFields = $filter('filter')(libSettings.Fields, { Missing: true });
                    //if no fields are missing we don't have to show the dialog
                    if (missingFields.length > 0) {
                        //only display those missing fields
                        libSettings.Fields = missingFields;
                        //we set a timeout that way there's a visual cue when going from file to file
                        $timeout(function () {
                            service.showPopup = true;
                        }, 100);
                    }
                    else {
                        showDialogDeffered.resolve('OK');
                    }
                }
                else {
                    //show the error dialog
                    libSettings.Fields = nonEditable;
                    $timeout(function () {

                        service.showErrorFields = true;
                        service.showPopup = true;
                    }, 100);
                }


            });

            return showDialogDeffered.promise;
        }

        function addToQueue() {
            service.recordQueue.push({
                tableNumber: service.currentRecord.tableNumber,
                fileId: service.currentRecord.fileId,
                majRev: service.currentRecord.majRev,
                minRev: service.currentRecord.minRev,
                filename: service.currentRecord.filename,
                librarySettings: service.currentLibSettings
            });
        }

        function processQueue(list) {
            var deferred = $q.defer();

            var promise = $q.all([]);

            if (service.recordQueue.length == 0) {
                deferred.resolve();
            }

            angular.forEach(service.recordQueue, function (item, index) {

                console.log(list);
                promise = promise.then(function () {
                    var d = $q.defer();

                    var newItem = $filter('filter')(list, { fileId: item.fileId })[0];

                    item.majRev = newItem.updateSI.majRev;
                    item.minRev = newItem.updateSI.minRev;

                    updateRecord(item, true).then(function () {
                        console.log("updated record", item.filename);
                        d.resolve();
                        if (index == service.recordQueue.length - 1) {
                            //slx.list = itemsToProcess;
                            //resolve main
                            service.recordQueue = [];
                            deferred.resolve();
                        }
                    });

                    return d.promise;
                });


            });



            return deferred.promise;
        }

        function closeDialog(answer) {
            service.showPopup = false;
            service.showErrorFields = false;
            showDialogDeffered.resolve(answer);
        }

        function showErrorDialog(message) {
            service.showPopup = false;
            service.showError = true;
            service.errorMessage = message;
            return showDialogDeffered.promise;
        }

        function closeError() {
            service.showError = false;
            showDialogDeffered.resolve('CANCEL');
        }

        ////////////////////////////////////////
        // Update Document - Required Fields
        // 
        function UpdateDocument(fieldValues, record) {
            var deferred = $q.defer();
            var commandService = $injector.get('commandService');

            dataCardService.UpdateDocument(fieldValues,
                record.SCHEMA_S_LONGNAME,
                record.SCHEMA_S_SRCDB,
                record.SCHEMA_S_FILEID,
                record.SCHEMA_S_MAJREV,
                record.SCHEMA_S_MINREV,
                record.SCHEMA_S_LIBID
            ).then(function () {
                deferred.resolve();
            }, function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        return service;



    }
})();